module.exports = __webpack_public_path__ + "static/media/favicon.7429f8fc.png";